export const DEFAULT_TITLE = 'Numerator Question Library';
